function initGlostick(user, impersonatedUser = null) {
  let accountLinks = []

  const glostickOpts = {
    logoutUrl: '/logout',
    targetSelector: 'body',
    appName: 'Heroku Data',
    accountLinks: accountLinks,
    helmet: false,
    mainContentId: '#root',
    footerId: '#belostick'
  }

  glostickOpts.userEmail = impersonatedUser
    ? impersonatedUser.email
    : user.email
  glostickOpts.userName = impersonatedUser ? impersonatedUser.name : user.name

  if (user.email.endsWith('@heroku.com')) {
    const identityLink = impersonatedUser
      ? {
          href: '/release',
          label: 'Release Identity',
          icon: 'assumeIdentity'
        }
      : {
          href: '/impersonate',
          label: 'Assume Identity',
          icon: 'assumeIdentity'
        }

    accountLinks.push(identityLink)
  }

  // init glostick
  window.Glostick.init(glostickOpts)
  document.addEventListener('DOMContentLoaded', function() {
    var element = document.getElementById('copyright-year')
    if (element) {
      element.innerHTML = new Date().getFullYear()
    }
  })
}

export default initGlostick
